export const HTTP_OK = 200;
export const HTTP_CREATED = 201;
export const HTTP_NO_CONTENT = 204;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_ACCESS_DENIED = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_TIMEOUT = 408;
export const HTTP_EXIST = 409;
export const HTTP_SERVER_ERROR = 500;
export const HTTP_NOT_MODIFIED = 304;
export const HTTP_REDIRECT = 302;
